/* =============================================================================
   HK catalog drawer (header) — opens/closes the <details> mega menu, sizes its
   columns, and locks it while the hero catalog is on screen.
   Menu behaviour (hover / keyboard / touch / product cards) lives in
   hk-catalog-core.js and is shared with the hero section.
   ============================================================================= */
(function () {
  'use strict';
  var HK = window.HKCatalog;
  if (!HK || window.__hkDrawerLoaded) return;
  window.__hkDrawerLoaded = true;

  var mqDesktop = HK.mqDesktop;
  var menus = [];

  function openDetails(details) {
    if (details && !details.hasAttribute('open')) details.setAttribute('open', '');
  }
  function closeDetails(details) {
    if (details && details.hasAttribute('open')) details.removeAttribute('open');
  }
  function closeAllExcept(current) {
    document.querySelectorAll('.hk-hdr-cat [data-hk-cat-details]').forEach(function (d) {
      if (d !== current) closeDetails(d);
    });
  }
  function canOpen(root) {
    return !(root && root.classList.contains('hk-locked'));
  }
  /* page scroll lock only for the full-screen (phone/tablet) panel */
  function setBodyLock(isOpen) {
    document.body.classList.toggle('hk-cat-open', !!isOpen && !mqDesktop.matches);
  }

  /* ---------- column sizing per stage (desktop) ---------- */
  function applyLayout(root, stage) {
    if (root.__hkLayout === stage && mqDesktop.matches) return;
    root.__hkLayout = stage;

    var panel = root.querySelector('.hk-hdr-cat__panel');
    var cat3 = root.querySelector('.hk-cat3');
    var l2Col = root.querySelector('.hk-cat3__l2');
    var l3Col = root.querySelector('.hk-cat3__l3');

    function l3Reset() {
      if (l3Col) { l3Col.style.left = ''; l3Col.style.width = ''; l3Col.style.overflowY = ''; }
    }

        /* a category without sub-categories shows its products in a wide pane (same as the hero catalog),
       so a 6-card page fits as 3 columns x 2 rows */
    if (stage === 'direct') {
      if (l2Col) l2Col.style.display = 'none';
      if (l3Col) {
        l3Col.style.display = '';
        l3Col.style.left = 'var(--hk-cat-rail-w, 440px)';
        l3Col.style.width = 'clamp(400px, 55vw, 760px)';
        l3Col.style.overflowY = 'auto';
      }
      if (cat3) {
        cat3.style.minHeight = 'auto';
        cat3.style.gridTemplateColumns = 'var(--hk-cat-rail-w, 440px) minmax(760px, 1fr)';
      }
      if (panel) panel.style.width = 'min(calc(var(--hk-cat-rail-w, 440px) + 760px), calc(100vw - 24px))';
      return;
    }

    if (!mqDesktop.matches) {
      /* phone / tablet: pure CSS layout */
      if (l2Col) l2Col.style.display = '';
      if (l3Col) l3Col.style.display = '';
      l3Reset();
      if (cat3) { cat3.style.gridTemplateColumns = ''; cat3.style.minHeight = ''; }
      if (panel) panel.style.width = '';
      return;
    }

    if (stage === 1) {
      if (l2Col) l2Col.style.display = 'none';
      if (l3Col) l3Col.style.display = 'none';
      l3Reset();
      if (cat3) { cat3.style.gridTemplateColumns = '1fr'; cat3.style.minHeight = ''; }
      if (panel) panel.style.width = 'min(var(--hk-cat-rail-w, 440px), calc(100vw - 24px))';
      return;
    }

    if (stage === 2) {
      if (l2Col) l2Col.style.display = '';
      if (l3Col) l3Col.style.display = 'none';
      l3Reset();
      if (cat3) {
        cat3.style.minHeight = '';
        cat3.style.gridTemplateColumns = 'var(--hk-cat-rail-w, 440px) var(--hk-l2-w, 360px)';
      }
      if (panel) panel.style.width = 'min(calc(var(--hk-cat-rail-w, 440px) + var(--hk-l2-w, 360px)), calc(100vw - 24px))';
      return;
    }

    /* stage 3 */
    if (l2Col) l2Col.style.display = '';
    if (l3Col) l3Col.style.display = '';
    l3Reset();
    if (cat3) {
      cat3.style.minHeight = '';
      cat3.style.gridTemplateColumns = 'var(--hk-cat-rail-w, 440px) var(--hk-l2-w, 360px)';
    }
    if (panel) panel.style.width = 'min(calc(100vw - 24px), calc(var(--hk-cat-rail-w, 440px) + var(--hk-l2-w, 360px) + clamp(400px, 45vw, 700px)))';
  }

  /* ---------- one drawer ---------- */
  function bindRoot(root) {
    if (root.dataset.hkBound === '1') return;
    root.dataset.hkBound = '1';

    var details = root.querySelector('[data-hk-cat-details]');
    var overlay = root.querySelector('[data-hk-cat-overlay]');
    var closeBtn = root.querySelector('[data-hk-cat-close]');
    var summary = root.querySelector('.hk-hdr-cat__trigger');

    var menu = HK.bindMenu(root, {
      setStage: function (stage) { applyLayout(root, stage); },
      canInteract: function () { return canOpen(root); },
      isOpen: function () { return !!details && details.hasAttribute('open'); }
    });
    /* theme-editor re-renders replace the header: drop menus whose root left the page */
    menus = menus.filter(function (m) { return m.root.isConnected; });
    menus.push({ root: root, menu: menu });

    if (summary) {
      summary.addEventListener('click', function (e) {
        if (!canOpen(root)) { e.preventDefault(); e.stopPropagation(); return; }
        /* hover opens the menu on desktop: a mouse click on the trigger must not toggle it shut again.
           (keyboard Enter/Space has click.detail === 0 and still toggles) */
        if (HK.isHoverDesktop() && e.detail > 0 && details.hasAttribute('open')) e.preventDefault();
      });
    }

    if (details && details.hasAttribute('open') && !mqDesktop.matches) details.removeAttribute('open');

    if (overlay) overlay.addEventListener('click', function () { closeDetails(details); });
    if (closeBtn) closeBtn.addEventListener('click', function () { closeDetails(details); });

    if (details) {
      details.addEventListener('toggle', function () {
        var isOpen = details.hasAttribute('open');

        if (isOpen && !canOpen(root)) { closeDetails(details); return; }

        if (isOpen) {
          closeAllExcept(details);
          root.__hkLayout = null;
          menu.reset();
          var firstL1 = root.querySelector('[data-hk-l1-btn]');
          if (firstL1) firstL1.classList.add('is-active');

          /* phone/tablet: show the first category's sub-list straight away */
          if (!mqDesktop.matches && root.querySelector('[data-hk-l2-pane="l1-1"] [data-hk-l2-btn]')) {
            menu.activateL1('l1-1');
          }
          menu.warm();
        }

        setBodyLock(isOpen);
      });
    }

    /* ----- hover open (with intent) / delayed close (desktop mouse) -----
       A pointer that only crosses the button on its way elsewhere no longer opens the menu and dims the page:
       it has to rest ~150 ms (UX-045). Keyboard (Enter / Space on the summary) still opens at once. */
    var HOVER_INTENT_MS = 150;
    var closeTimer = null;
    var openTimer = null;
    function scheduleClose() {
      if (!HK.isHoverDesktop()) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { closeDetails(details); }, 140);
    }
    function cancelClose() {
      clearTimeout(closeTimer);
      closeTimer = null;
    }

    function hoverOpen() {
      openTimer = null;
      root.classList.add('hk-is-hovered');           /* hover dim, routed through the global HKShadow */
      if (!canOpen(root)) return;
      openDetails(details);
    }

    root.addEventListener('mouseenter', function () {
      if (!HK.isHoverDesktop()) return;
      cancelClose();
      clearTimeout(openTimer);
      /* back on a menu that is still open (inside the close delay): no new wait */
      if (details && details.hasAttribute('open')) { hoverOpen(); return; }
      openTimer = setTimeout(hoverOpen, HOVER_INTENT_MS);
    });

    root.addEventListener('mouseleave', function () {
      clearTimeout(openTimer);
      openTimer = null;
      root.classList.remove('hk-is-hovered');
      if (window.HKShadow) window.HKShadow.update();
      if (!HK.isHoverDesktop()) return;
      scheduleClose();
      menu.retreat();
    });

    /* desktop: close when keyboard focus leaves the menu (mouse users are handled by mouseleave) */
    root.addEventListener('focusout', function (e) {
      if (!mqDesktop.matches) return;
      if (e.relatedTarget && root.contains(e.relatedTarget)) return;
      if (root.matches(':hover')) return;
      closeDetails(details);
    });

    menu.reset();
  }

  function bindAll() {
    document.querySelectorAll('.hk-hdr-cat[data-hk-cat]').forEach(bindRoot);
  }

  /* ---------- hero catalog on screen => the header one is locked ---------- */
  var lockObserver = null;
  function applyLock(locked) {
    document.querySelectorAll('.hk-hdr-cat--enter').forEach(function (cat) {
      cat.classList.toggle('hk-locked', locked);
      cat.toggleAttribute('inert', locked);
      if (locked) closeDetails(cat.querySelector('details'));
    });
  }
  function initLock() {
    if (lockObserver) { lockObserver.disconnect(); lockObserver = null; }
    var heroes = document.querySelectorAll('.hk-catsl');
    if (!heroes.length || !('IntersectionObserver' in window)) { applyLock(false); return; }
    var visible = new Set();
    lockObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target);
      });
      applyLock(visible.size > 0);
    });
    heroes.forEach(function (h) { lockObserver.observe(h); });
  }

  /* ---------- global listeners (bound once) ---------- */
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { menus.forEach(function (m) { m.menu.retreat(); }); }, 120);
  });

  /* Escape closes the menu and hands focus back to the trigger */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.hk-hdr-cat').forEach(function (root) {
      var d = root.querySelector('[data-hk-cat-details]');
      if (!d || !d.hasAttribute('open')) return;
      var hadFocus = root.contains(document.activeElement);
      closeDetails(d);
      var s = root.querySelector('.hk-hdr-cat__trigger');
      if (hadFocus && s) s.focus({ preventScroll: true });
    });
  });

  /* theme editor: a re-rendered header / hero section needs binding again */
  document.addEventListener('shopify:section:load', function () { bindAll(); initLock(); });

  bindAll();
  initLock();
})();